<template>
    <article role="region" :aria-labelledby="id"
        class="flex items-start gap-4 sm:gap-6 rounded-3xl p-4 sm:p-6 bg-[var(--background-section)]">
        <!-- Icon tile -->
        <div
            class="relative w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 rounded-2xl flex items-center justify-center bg-[var(--background-primary)] overflow-hidden shrink-0">
            <div
                class="w-14 h-14 sm:w-[72px] sm:h-[72px] md:w-[92px] md:h-[92px] rounded-full flex items-center justify-center bg-gradient-to-br from-[rgba(71,209,140,0.25)] to-[rgba(102,163,255,0.25)] blur-[20px]">
            </div>
            <component :is="icon" class="!w-8 !h-8 sm:!w-10 sm:!h-10 md:!w-12 md:!h-12 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-white opacity-90" />
        </div>

        <!-- Copy -->
        <div class="min-w-0">
            <h3 :id="id" class="text-[var(--text-secondary)] text-lg sm:text-xl md:text-2xl font-semibold mb-1">
                {{ title }}
            </h3>
            <p class="text-[var(--text-gray)] text-sm sm:text-base leading-relaxed">
                {{ description }}
            </p>
        </div>
    </article>
</template>

<script setup lang="ts">

interface Props {
    title: string;
    description: string;
    icon: any;
}

const props = defineProps<Props>();

const id = computed(() => props.title.replace(/\s+/g, "-").toLowerCase());
</script>
